module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background",
    attrs: {
      "id": (_vm.videoId + "_vidControlsContainer")
    }
  }, [_c('div', {
    staticClass: "vidGradientTop",
    attrs: {
      "id": (_vm.videoId + "_vidGradientTop")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "vidGradient",
    attrs: {
      "id": (_vm.videoId + "_vidGradient")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "vidControls",
    attrs: {
      "id": (_vm.videoId + "_vidControls")
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "vctrl_rewind",
    attrs: {
      "id": (_vm.videoId + "_rewind")
    },
    on: {
      "click": function($event) {
        _vm.vid.currentTime = 0
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "vctrl_playpause paused",
    attrs: {
      "id": (_vm.videoId + "_playpause")
    },
    on: {
      "click": _vm.togglePause
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "vctrl_progressBar",
    attrs: {
      "id": (_vm.videoId + "_progressBar")
    },
    on: {
      "click": _vm.onProgBarClick
    }
  }, [_c('div', {
    staticClass: "vctrl_progress",
    staticStyle: {
      "width": "12%"
    },
    attrs: {
      "id": (_vm.videoId + "_progress")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "vctrl_playhead",
    staticStyle: {
      "left": "12%"
    },
    attrs: {
      "id": (_vm.videoId + "_playhead")
    },
    on: {
      "touchstart": _vm.touchHandler,
      "mousedown": _vm.onScrubberDown
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "vctrl_time",
    attrs: {
      "id": (_vm.videoId + "_time")
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01e4d1f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/video-controls/Video-Controls.vue
// module id = 219
// module chunks = 1